export interface Competitor {
  id: string;
  name: string;
  descriptionKey: string;
  highlightKey: string;
}

export interface ComparisonCategory {
  id: string;
  labelKey: string;
  features: ComparisonFeature[];
}

export interface ComparisonFeature {
  id: string;
  labelKey: string;
  inmuebleRed: 'yes' | 'partial' | 'no';
  sperant: 'yes' | 'partial' | 'no';
  salesforce: 'yes' | 'partial' | 'no';
}

export const competitors: Competitor[] = [
  {
    id: 'inmueble_red',
    name: 'Inmueble.red',
    descriptionKey: 'comparison:competitors.inmuebleRed.description',
    highlightKey: 'comparison:competitors.inmuebleRed.highlight',
  },
  {
    id: 'sperant',
    name: 'Sperant',
    descriptionKey: 'comparison:competitors.sperant.description',
    highlightKey: 'comparison:competitors.sperant.highlight',
  },
  {
    id: 'salesforce',
    name: 'Salesforce',
    descriptionKey: 'comparison:competitors.salesforce.description',
    highlightKey: 'comparison:competitors.salesforce.highlight',
  },
];

export const comparisonCategories: ComparisonCategory[] = [
  {
    id: 'finance',
    labelKey: 'comparison:categories.finance',
    features: [
      {
        id: 'payment_schedules',
        labelKey: 'comparison:features.paymentSchedules',
        inmuebleRed: 'yes',
        sperant: 'yes',
        salesforce: 'no',
      },
      {
        id: 'multi_currency',
        labelKey: 'comparison:features.multiCurrency',
        inmuebleRed: 'yes',
        sperant: 'partial',
        salesforce: 'yes',
      },
      {
        id: 'cronogramas_letras',
        labelKey: 'comparison:features.cronogramasLetras',
        inmuebleRed: 'yes',
        sperant: 'yes',
        salesforce: 'no',
      },
      {
        id: 'voucher_ocr',
        labelKey: 'comparison:features.voucherOcr',
        inmuebleRed: 'yes',
        sperant: 'no',
        salesforce: 'no',
      },
      {
        id: 'collections_ai',
        labelKey: 'comparison:features.collectionsAi',
        inmuebleRed: 'yes',
        sperant: 'partial',
        salesforce: 'partial',
      },
      {
        id: 'finance_module',
        labelKey: 'comparison:features.financeModule',
        inmuebleRed: 'yes',
        sperant: 'partial',
        salesforce: 'partial',
      },
    ],
  },
  {
    id: 'crm',
    labelKey: 'comparison:categories.crm',
    features: [
      {
        id: 'lead_management',
        labelKey: 'comparison:features.leadManagement',
        inmuebleRed: 'yes',
        sperant: 'yes',
        salesforce: 'yes',
      },
      {
        id: 'opportunity_pipeline',
        labelKey: 'comparison:features.opportunityPipeline',
        inmuebleRed: 'yes',
        sperant: 'yes',
        salesforce: 'yes',
      },
      {
        id: 'ai_lead_scoring',
        labelKey: 'comparison:features.aiLeadScoring',
        inmuebleRed: 'yes',
        sperant: 'yes',
        salesforce: 'partial',
      },
      {
        id: 'smart_filters',
        labelKey: 'comparison:features.smartFilters',
        inmuebleRed: 'yes',
        sperant: 'no',
        salesforce: 'no',
      },
      {
        id: 'next_best_action',
        labelKey: 'comparison:features.nextBestAction',
        inmuebleRed: 'yes',
        sperant: 'no',
        salesforce: 'partial',
      },
    ],
  },
  {
    id: 'security',
    labelKey: 'comparison:categories.security',
    features: [
      {
        id: 'immutable_audit',
        labelKey: 'comparison:features.immutableAudit',
        inmuebleRed: 'yes',
        sperant: 'no',
        salesforce: 'partial',
      },
      {
        id: 'multi_tenant_isolation',
        labelKey: 'comparison:features.multiTenantIsolation',
        inmuebleRed: 'yes',
        sperant: 'yes',
        salesforce: 'yes',
      },
      {
        id: 'rbac_jwt',
        labelKey: 'comparison:features.rbacJwt',
        inmuebleRed: 'yes',
        sperant: 'yes',
        salesforce: 'yes',
      },
      {
        id: 'lpdp_compliance',
        labelKey: 'comparison:features.lpdpCompliance',
        inmuebleRed: 'yes',
        sperant: 'yes',
        salesforce: 'partial',
      },
      {
        id: 'encryption_at_rest',
        labelKey: 'comparison:features.encryptionAtRest',
        inmuebleRed: 'yes',
        sperant: 'partial',
        salesforce: 'yes',
      },
    ],
  },
  {
    id: 'platform',
    labelKey: 'comparison:categories.platform',
    features: [
      {
        id: 'peru_real_estate_native',
        labelKey: 'comparison:features.peruRealEstateNative',
        inmuebleRed: 'yes',
        sperant: 'yes',
        salesforce: 'no',
      },
      {
        id: 'modular_pricing',
        labelKey: 'comparison:features.modularPricing',
        inmuebleRed: 'yes',
        sperant: 'no',
        salesforce: 'no',
      },
      {
        id: 'edge_deployment',
        labelKey: 'comparison:features.edgeDeployment',
        inmuebleRed: 'yes',
        sperant: 'no',
        salesforce: 'yes',
      },
      {
        id: 'api_first',
        labelKey: 'comparison:features.apiFirst',
        inmuebleRed: 'yes',
        sperant: 'yes',
        salesforce: 'yes',
      },
      {
        id: 'real_time_ai',
        labelKey: 'comparison:features.realTimeAi',
        inmuebleRed: 'yes',
        sperant: 'no',
        salesforce: 'partial',
      },
    ],
  },
];
